import React from 'react';
import { useSelector } from 'react-redux';

export default function Low({ symbolId, digits }) {
    const symbol = useSelector(state => state.updateSymbol.symbols?.[symbolId])

    return <span>{symbol?.low?.toFixed(digits || symbol.digits)}</span>;
}
